import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-project_chart-bar",
  "use": "icon-project_chart-bar-usage",
  "viewBox": "0 0 28 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 28\" id=\"icon-project_chart-bar\"><g transform=\"translate(1 4)\" stroke=\"currentColor\" fill=\"transparent\" stroke-width=\"2\"><rect x=\"1\" y=\"1\" width=\"24\" height=\"20\" rx=\"4\" /><path stroke-linecap=\"round\" d=\"M7 10v7M13 5.938V17M18.903 17v-4.874\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol